<template>
  <div class="locale-changer p-mt-6">
    <Dropdown 
      v-model="$i18n.locale" 
      :options="$i18n.availableLocales" 
      placeholder="" 
      :class="customclass"
      :aria-label="$t('lang.set_language_button')">
      <template #value="slotProps">
              <!-- <img src="assets/demo/flags/flag_placeholder.png" :class="'flag flag-' + lang[slotProps.value].flag" width="30" /> -->
              {{lang[slotProps.value].name}}
      </template>
      <template #option="slotProps">
              <!-- <img src="assets/demo/flags/flag_placeholder.png" :class="'flag flag-' + lang[slotProps.option].flag" width="30" /> -->
              {{lang[slotProps.option].name}}
      </template>
    </Dropdown>
  </div>
</template>

<script>

export default {
    props: {
      customclass: String
    },
    data() {
        return {
            lang: {
              en: {
                flag: 'gb',
                name: 'English'
              },
              it: {
                flag: 'it',
                name: 'Italiano'
              },
              ru: {
                flag: 'ru',
                name: 'русский'
              },
              es: {
                flag: 'es',
                name: 'Español'
              },
              du: {
                flag: 'nl',
                name: 'Nederlands'
              },
              fr: {
                flag: 'fr',
                name: 'Français'
              },
              de: {
                flag: 'de',
                name: 'Deutsche'
              },
              'en-US': {
                flag: 'us',
                name: 'United States'
              },
              ja: {
                flag: 'jp',
                name: 'やまと'
              },
              pt: {
                flag: 'br',
                name: 'Português'
              },
              ko: {
                flag: 'kr',
                name: '한국어'
              },
              hi: {
                flag: 'in',
                name: 'हिन्दी'
              },
              id: {
                flag: 'id',
                name: 'Bahasa Indonesia'
              },
              zh: {
                flag: 'cn',
                name: '中文'
              },
            }
        };
    },
    watch: {
      '$i18n.locale': 'changeLocale'
    },
    methods: {
      changeLocale: async function() {
        this.$store.commit('preferences/locale', this.$i18n.locale);
      },
    }
}
</script>

<style>
.rightbar-local-changer{
  width:100%;
  background-color: rgb(252,251,251);
}
.p-dropdown-panel{
  background-color: rgb(252,251,251);
}
</style>
